import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  shoppingCartTitle: {
    fontFamily: 'proximanova-bold',
    padding: 20,
  },
  shoppingCart: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 350,
    },
    maxWidth: 400,
    width: '100%',
    borderRadius: 0,
    backgroundColor: '#F3F3F3',
  },
  fullWidth: {
    maxWidth: 'initial',
  },
  shoppingContainer: {
    padding: 20,
  },
  outline: {
    border: '1px solid',
    borderColor: '#e2e2e2',
  },
  prices: {
    border: '1px solid',
    borderColor: '#e2e2e2',
    borderRadius: '50px',
    backgroundColor: 'white',
    flexGrow: 1,
    padding: '5px 20px',
    margin: '0 20px',
  },
  placeOrderButtonContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  placeOrderButton: {
    width: '100%',
  },
})

export default makeStyles(styles)
